// CallButton.js
import React from "react";
// import { Button } from "antd";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { useCall } from "./CallPage";
import { CallIcon } from '../../../../components/Icons/Icons';

function CallButton({ number, EntityData, setNaCTrigger }) {
    const { CommApiValues } = useSelector((state) => state.callingRedux);
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const { makeCall, isCalling } = useCall();

    if (!number || number === "0") return null;

    return (
        <div className={(isCalling || CommApiValues === "") ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
            role="button" style={{ marginLeft: 5, color: CommApiValues === "" ? "gray" : "darkgreen" }}
            tabIndex={0} title={CommApiValues === "" ? "Not configured" : isCalling ? "Call in progress" : "Call"}
            onClick={() => {
                if (CommApiValues !== "" && !isCalling)
                    if (EntityData && EntityData.type !== "User") {
                        setNaCTrigger("trigger")
                        makeCall(profile, number, EntityData, setNaCTrigger);
                    } else {
                        makeCall(profile, number, EntityData);
                    }
            }}
            onKeyDown={(event) => {
                if (!isCalling && CommApiValues !== "" && event.key === 'Enter' || event.key === ' ') {
                    if (EntityData && EntityData.type !== "User") {
                        setNaCTrigger("trigger")
                        makeCall(profile, number, EntityData, setNaCTrigger);
                    } else {
                        makeCall(profile, number, EntityData);
                    }
                }
            }}
            aria-label='call'
        > <CallIcon /></div>
    );
}
CallButton.propTypes = {
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    EntityData: PropTypes.object,
    setNaCTrigger: PropTypes.func
};
export default CallButton;
